import { ApplyFormModalContent, ApplyFormModalContentProps } from '~/components/ApplyFormModal/ApplyFormModalContent';
import { ApplyFormContextProvider, ApplyFormContextProviderProps } from '~/contexts/ApplyFormContext/ApplyFormContext';

type ApplyFormModalProps = ApplyFormModalContentProps & ApplyFormContextProviderProps;

export const ApplyFormModal = ({ applyType, onClose, jobOffer, jobPost }: ApplyFormModalProps) => (
  <ApplyFormContextProvider applyType={applyType} jobOffer={jobOffer} jobPost={jobPost}>
    <ApplyFormModalContent onClose={onClose} />
  </ApplyFormContextProvider>
);
